export default __webpack_public_path__ + "static/media/privilege-s-sport.dc956817.svg";